import { CreateEquipmentDto, EquipmentDict } from "../../../../model/Dto/Dict/Equipment";
import { ApiRequest, RequestMethod } from "../../../request";

export async function createEquipment(data: CreateEquipmentDto): Promise<EquipmentDict | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl("/api/equipment");
    apiRequest.setJsonBody(data);
    const response: any = await apiRequest.send();
    if (response.status === 200) return response.data;
    return null;
}
